export default __webpack_public_path__ + "QuickenLogoReveal.json";